import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";


const gmapApplicationApi = createApi({
    reducerPath: 'gmapApplicationApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        AddEditGMACourseDetailsBatch: builder.mutation({
            query: (details) => ({
                url: '/GMAPAccount/AddEditGMACourseDetailsBatch',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GmaCourseMembersList: builder.mutation({
            query: (details) => ({
                url: '/GMAPAccount/GmaCourseMembersList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAdminDetailList: builder.mutation({
            query: (details) => ({
                url: '/Account/GetAdminDetailList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditAdminDetails: builder.mutation({
            query: (details) => ({
                url: '/Account/AddEditAdminDetails',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteAdminDetailsById: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Account/DeleteAdminDetailsById`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAdminDetailById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Account/GetAdminDetailById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),

})

export const {
    useAddEditGMACourseDetailsBatchMutation,
    useGmaCourseMembersListMutation,
    useGetAdminDetailListMutation,
    useAddEditAdminDetailsMutation,
    useDeleteAdminDetailsByIdMutation,
    useLazyGetAdminDetailByIdQuery
} = gmapApplicationApi;

export default gmapApplicationApi;